import React, { useState, useMemo, useCallback } from "react"
import { observer } from "mobx-react-lite"
import useNavigation from "~hooks/useNavigation"
import useSelectPageEffect from "~hooks/useSelectPageEffect"
import { SearchBarWithAvatars } from "~components/search-bar-with-avatars"
import { ContactList } from "~components/contact-list"
import { Event, EventNames, ChatMemberARData, FLAG_ACK } from "~proto"
import styled from '~/ui/styled'
import { useStores } from "~models"

const Container = styled.SafeAreaView`
  flex: 1;
`

const AddGroupMember: React.FC = () => {
  const {
    chatStore: { current },
    eventStore,
    contactStore,
    userStore,
  } = useStores()
  const navigation = useNavigation()

  const [search, setSearch] = useState("")

  const [selecteds, setSelecteds] = useState([])

  const canSubmit = useMemo(() => selecteds.length > 0, [selecteds])

  const joinedMemberUserIDs = current.members.map((member) => member.user_id)

  const sections = [
    ...contactStore.byNameWithFilterAndExcludeIds(new RegExp(search, "i"), joinedMemberUserIDs),
  ]

  const avatars = selecteds.map((s) => {
    const user = userStore.users.get(s)
    return {
      title: user.name,
      avatar: user.avatar,
    }
  })

  const onSubmit = () => {
    const evt = new Event<ChatMemberARData>(EventNames.CHAT_MEMBER_ADD, {
      chat_id: current.id,
      chat_cid: current.chat_id,
      user_ids: selecteds,
    })
    eventStore.publish(evt, { flags: FLAG_ACK })
    navigation.goBack()
  }

  const onItemClick = useCallback(
    ({ user }) => {
      const { id } = user
      if (selecteds.find((x) => x === id)) {
        setSelecteds(selecteds.filter((x) => x !== id))
      } else {
        setSelecteds([...selecteds, id])
      }
    },
    [selecteds],
  )

  useSelectPageEffect({
    canSubmit,
    onSubmit,
    selecteds,
  })

  return (
    <Container>
      <SearchBarWithAvatars
        selecteds={avatars}
        search={search}
        setSearch={setSearch}
        inputSetting={{
          placeholder: "输入用户名",
        }}
      />
      <ContactList sections={sections} onItemClick={onItemClick} selecteds={selecteds} />
    </Container>
  )
}
export default observer(AddGroupMember)
